<template>
  <div id="policy_wrapper">
      <div id="policy_wrap">
          <div id="policy_header">
              <div class="history_back">
                  <img src="@/assets/images/ex-show@2x.png" style="width:15px;" @click="goToBack()">
              </div>
              <span>
                  <h1>고시락 개인정보처리방침</h1>
              </span>
          </div>
      </div>
      <div id="policy_contents">
          <span class="policy_title_text">개인정보처리방침</span>
          <span class="policy_content_text">
              <span class="policy_content_text_bold">㈜휴식(이하 “회사”라 합니다)는 이용자의 개인정보를 중요시하며, ‘정보통신망 이용촉진 및 정보보호 등에 관한 법률’ 및 ‘개인정보 보호법’ 등에 관한 법률을 준수하고 있습니다. 회사는 다음과 같은 내용으로 개인정보 처리방침을 통하여 이용자가 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 이루어지고 있는지 알려드립니다.</span>
          </span><br /><br />
          <span class="policy_content_text">
              <span class="policy_content_text_bold">1. 개인정보의 수집 목적과 수집에 대한 동의</span><br />
              회사는 마케팅 및 광고에의 활용, 신규 서비스(제품) 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공 등을 목적으로 이용자가 동의한 경우에만 개인정보를 수집합니다.
          </span><br /><br />
          <span class="policy_content_text">
              <span class="policy_content_text_bold">2. 개인정보 수집 항목</span><br />
              ① 입실문의 및 기타 모든 문의 신청란. 필수항목 : 전화번호
          </span><br /><br />
          <span class="policy_content_text">
              <span class="policy_content_text_bold">3. 개인정보의 보유 및 이용기간</span><br />
              ① 회사는 개인정보 수집 및 이용목적이 달성된 경우 예외 없이 해당 정보를 지체 없이 파기합니다. 다만, 법령의 규정에 의하여 보존할 필요성이 있는 경우에는 다음과 같이 보유합니다. 관련법률: 전자상거래 등에서의 소비자보호에 관한 법률, 통신비밀보호법 목적 및 보유기간: 계약 또는 청약철회 등에 관한 기록: 5년 대금결제 및 재화등의 공급에 관한 기록: 5년 소비자의 불만 또는 분쟁처리에 관한 기록: 3년 표시∙광고에 관한 기록: 6개월 / 로그인에 관한 기록: 3개월<br />② 회사는 이용자의 동의를 받아 보유하고 있는 거래정보 등을 이용자가 열람 요청하는 경우 지체 없이 열람, 확인할 수 있도록 조치합니다.
          </span><br /><br />
          <span class="policy_content_text">
              <span class="policy_content_text_bold">4. 개인정보 파기절차 및 방법</span><br />
              이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 회사의 개인정보 파기절차 및 방법은 다음과 같습니다.<br />
              ① 파기절차 이용자가 제공한 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 제4조의 관련법령에 따라 일정 기간 저장 후 파기합니다.<br />
              ② 파기 방법 종이로 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다. 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 파기합니다.<br />
              ③ “회사”는 서비스를 장기간(1년 또는 다른 법령에서 별도로 정한 기간, 회원이 달리 정한 기간) 이용하지 아니하는 회원의 개인정보를 보호하기 위하여 해당 기간 경과 후 다른 회원의 개인정보와 분리하여 별도로 저장 및 관리하고, 해당 회원의 서비스 이용을 제한할 수 있습니다. 단, 회원이 서비스 이용의사를 표시한 경우 즉시 서비스 이용이 가능합니다.
          </span><br /><br />
          <span class="policy_content_text">
              <span class="policy_content_text_bold">5. 개인정보의 제3자 제공에 대한 동의</span><br />
              당사는 수집된 개인 정보를 "개인정보 수집, 이용목적 및 수집하는 개인정보 항목"에서 고지한 범위 내에서 이용하며, 동 범위를 초과하여 이용하거나 타인 또는 타기업, 기관에 제공하지 않습니다. 단, 고객 문의 시 문의사항의 신속한 해결을 위하여 필요한 경우 제공 받는 자, 제공 목적, 제공 항목, 이용 및 보유기간을 회원에게 고지하여 동의를 구한 후 아래와 같이 제 3자에게 제공합니다.<br />
              정보를 제공 받는 자: (주)HJ컴퍼니 개인정보 이용 목적: 광고입점/마케팅 제공하는 개인정보 항목: 이름, 연락처 개인정보 보유 및 이용기간: 재화 또는 서비스의 제공 목적이 달성된 후 파기(단, 관게법령에 정해진 규정에 따라 법정기간 동안 보관)
          </span><br /><br />
          <span class="policy_content_text">
              <span class="policy_content_text_bold">6. 개인정보의 처리위탁</span><br />
              회사는 개인정보의 처리 및 관리 등의 업무를 스스로 수행함을 원칙으로 하나, 필요한 경우 업무의 일부 또는 전부를 회사가 선정한 회사에 위탁할 수 있습니다.<br />
              수탁자 : (주)휴식 위탁업무 : 서비스 시스템 운영 및 유지보수 제공항목 : 이름, 연락처, 문의사항
          </span><br /><br />
          <span class="policy_content_text">
              <span class="policy_content_text_bold">7. 이용자 및 법정대리인의 권리와 그 행사방법</span><br />
              이용자 및 법정대리인은 언제든지 수집 정보에 대하여 수정, 동의철회, 삭제, 열람요청 등을 할 수 있으며, 회사는 지체 없이 처리해드리도록 하겠습니다. 다만, 동의철회 또는 삭제 시 서비스의 일부 또는 전부의 이용이 제한될 수 있습니다.
          </span><br /><br />
          <span class="policy_content_text">
              <span class="policy_content_text_bold">8. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</span><br />
              ① 쿠키(Cookie)는 웹사이트를 운영하는데 이용되는 서버가 이용자의 컴퓨터로 전송하는 아주 작은 텍스트 파일로서 이용자의 컴퓨터 하드디스크에 저장되고 있습니다. 따라서 여러분 스스로가 쿠키의 설치 및 수집에 대해 자율적으로 선택할 수 있으므로 수집을 거부할 수 있습니다. 다만, 쿠키의 저장을 거부할 경우 로그인이 필요한 일부 서비스의 이용에 제한이 생길 수 있습니다.<br />
              ② 쿠키 설정 거부 방법 1) Internet Explorer의 경우 : 웹 브라우저 상단의 “도구” 메뉴 > “인터넷 옵션” 메뉴 > “개인정보” 탭 > 직접 설정 2) Chrome의 경우 : 웹 브라우저 우측 상단의 아이콘 “ ” 선택 > “설정”선택 > 화면 하단의 “고급 설정 표시” 선택 >개인정보 섹션의 “콘텐츠 설정” 버튼 > 쿠키 섹션에서 직접 설정
          </span><br /><br />
          <span class="policy_content_text">
              <span class="policy_content_text_bold">9. 개인정보보호 책임자 및 담당자</span><br />
              당사는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보 보호책임자를 지정하고 있습니다.<br />
              ① 개인정보 보호책임자 성명: 백대선 연락처: 010-4661-9138 이메일: dev@huesik.co.kr<br />
              ② 개인정보 민원처리 담당부서 부서명: 운영 부서 이메일: official@huesik.co.kr 연락처: 02-911-9051<br />
          </span><br /><br />
          <span class="policy_content_text">
              <span class="policy_content_text_bold">10. 이용자의 권익침해에 대한 구제방법</span><br />
              이용자는 아래의 기관에 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다. (아래의 기관은 회사와는 별개의 기관으로서, 회사의 자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면 문의하여 주시기 바랍니다.)<br />
              ▶ 개인정보 침해신고센터 (한국인터넷진흥원 운영)<br />
              - 소관업무 : 개인정보 침해사실 신고, 상담 신청<br />
              - 홈페이지 : privacy.kisa.or.kr<br />
              - 전화 : (국번없이) 118<br />
              - 주소 : (138-950) 서울시 송파구 중대로 135 한국인터넷진흥원 개인정보침해신고센터<br />
              ▶ 개인정보 분쟁조정위원회 (한국인터넷진흥원 운영)<br />
              - 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)<br />
              - 홈페이지 : privacy.kisa.or.kr<br />
              - 전화 : (국번없이) 118<br />
              - 주소 : (138-950) 서울시 송파구 중대로 135 한국인터넷진흥원 개인정보침해신고센터<br />
              ▶ 대검찰청 사이버범죄수사단 : 02-3480-3573 (www.spo.go.kr)<br />
              ▶ 경찰청 사이버안전국 : 182 (http://cyberbureau.police.go.kr/index.do)<br />
              현재 개인정보 처리방침 공고일자 : 2019년 8월 30일<br />
              현재 개인정보 처리방침 시행일자 : 2018년 9월 1일
          </span><br /><br />
      </div>
  </div>
  </template>
  
  <script>
  export default {
      name: 'Policy',
  
      methods: {
          goToBack() {
              this.$router.push('/');
              // this.$router.go(-1);
          }
      }
  }
  </script>
  
  <style scoped>
  #policy_wrapper {
      height: 100%;
      max-width: 720px;
      margin: 0 auto;
      padding-top: 5px;
  }
  
  #policy_wrap {
      height: 100%;
      max-width: 720px;
      margin: 0 auto;
      padding-top: 56px;
  }
  
  #policy_header {
      position: fixed;
      top: 0;
      width: 100%;
      height: 60px;
      background: #fff;
      text-align: center;
      border-bottom: 1px solid #edf0f2;
      max-width: 720px;
  }
  
  #policy_header h1 {
      display: inline-block;
      position: relative;
      text-align: center;
      line-height: 3;
      margin: 8px;
      font-weight: bold;
      font-size: 16px;
  }
  
  #policy_contents {
      text-align: left;
      font-size: 14px;
      line-height: 2;
      letter-spacing: 0.2px;
      padding: 22px 22px 0px 22px;
      background-color: #fff;
  }
  
  .history_back {
      position: absolute;
      left: 0;
      margin-left: 15px;
      margin-top: 20px;
  }
  
  .policy_title_text {
      text-align: left;
      display: block;
      font-weight: 700;
      margin: 6px 0px;
  }
  
  .policy_content_text {
      text-align: left;
      display: inline-block;
      color: gray;
      font-size: 12px;
  }
  
  .policy_content_text_bold {
      font-weight: bold;
      font-size: 13px;
  }
  </style>
  